import site from '../content/site.json';

export type SiteContent = typeof site;

export function getSite(): SiteContent {
  return site;
}
